<template>
    <v-card>
        <v-card-text>
            <h3 class="mb-5">{{
                $t('editUserInformation.personalInformations')
            }}</h3>
            <form>
                <v-text-field
                    v-model="formData.firstName"
                    :error-messages="firstNameErrors"
                    :label="$t('editUserInformation.forms.firstName')"
                    type="string"
                    required
                    @input="$v.formData.firstName.$touch()"
                    @blur="$v.formData.firstName.$touch()"
                />

                <v-text-field
                    v-model="formData.lastName"
                    :error-messages="lastNameErrors"
                    :label="$t('editUserInformation.forms.lastName')"
                    type="string"
                    required
                    @input="$v.formData.lastName.$touch()"
                    @blur="$v.formData.lastName.$touch()"
                />

                <v-text-field
                    v-model="formData.phone"
                    :error-messages="phoneErrors"
                    :label="$t('editUserInformation.forms.phone')"
                    type="string"
                    required
                    @input="$v.formData.phone.$touch()"
                    @blur="$v.formData.phone.$touch()"
                />

                <v-menu
                    v-model="isBirthDatePickerVisible"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template
                        style="display:none;"
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            :label="$t('editUserInformation.forms.birthDate')"
                            prepend-icon="mdi-calendar"
                            readonly
                            :value="formData.birthDate | dateFormatFromSettings"
                            :error-messages="birthDateErrors"
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="formData.birthDate"
                        no-title
                        scrollable
                        @input="onBirthDatePickerInput"
                    />
                </v-menu>

                <v-text-field
                    v-model="formData.email"
                    :error-messages="emailErrors"
                    :label="$t('editUserInformation.forms.email')"
                    type="string"
                    required
                    @input="$v.formData.email.$touch()"
                    @blur="$v.formData.email.$touch()"
                />

                <v-card-actions>
                    <v-spacer />
                    <v-btn depressed @click="submit">
                        {{ $t('editUserInformation.forms.submit') }}
                    </v-btn>
                </v-card-actions>
            </form>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import editUserProfile from '@/validators/users/editUserProfile.mixin.js';

export default {
    name: 'profileInformationForm',

    mixins: [editUserProfile],

    data() {
        const defaultFormData = {
            firstName: '',
            lastName: '',
            phone: '',
            birthDate: '',
            email: ''
        };

        return {
            isBirthDatePickerVisible: false,
            formData: {
                ...defaultFormData
            },
            defaultFormData
        };
    },

    computed: {
        ...mapGetters({
            loggedUser: 'auth/getLoggedUser',
            isAdmin: 'auth/isAdmin'
        })
    },

    created() {
        this.setDefaultFormData();
    },

    methods: {
        ...mapActions({
            saveProfile: 'auth/saveProfile',
            refreshUser: 'auth/refreshUser'
        }),

        setDefaultFormData() {
            this.formData = this.loggedUser
                ? { ...this.loggedUser }
                : { ...this.defaultFormData };
        },

        onBirthDatePickerInput() {
            this.$v.formData.birthDate.$touch();
            this.clearServerErrors('birthDate');
            this.isBirthDatePickerVisible = false;
        },

        async submit() {
            try {
                this.$v.$touch();

                if (!this.isValid) {
                    return;
                }

                const updatedUserData = await this.saveProfile(this.formData);
                await this.refreshUser(updatedUserData);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('editUserInformation.success.title'),
                    text: this.$t('editUserInformation.success.text')
                });

                this.setDefaultFormData();
                this.$v.$reset();
            } catch (error) {
                if (this.checkForServerFormErrors(error)) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('editUserInformation.fail.title'),
                        text: this.$t('editUserInformation.fail.text')
                    });
                }

                console.error(error);
            }
        }
    }
};
</script>
